module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container text-center"
  }, [_c('h2', [_vm._v("We Welcome All Media Inquiries")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Please Contact:")]), _c('br'), _vm._v("\n      Retta Jitner, Founder & CEO, Pencils for Kids, Inc.")]), _vm._v(" "), _c('p', [_vm._v("Email: retta@pencilsforkidsinc.com"), _c('br'), _vm._v("\n      Phone: +1 323-595-1693")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1139c509!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/MediaInquiries.vue
// module id = 304
// module chunks = 1